import React from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const AddAnotherLawFirmDialog = ({
  showAddFirmDialog,
  setShowAddFirmDialog,
  requestResult,
  searchResults,
  isSearching,
  handleSearchFirms,
  handleSelectNewFirm,
  selectedNewFirm,
  selectedNewLocation,
  firmLocationsNew,
  setSelectedNewLocation,
  requestMessage,
  setRequestMessage,
  handleRequestAccess,
  requestingAccess,
}) => {
  return (
    <Dialog open={showAddFirmDialog} onClose={() => setShowAddFirmDialog(false)} fullWidth maxWidth="sm">
      <DialogTitle>Add Another Law Firm</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={3} mt={1}>

          {requestResult && (
            <Alert severity={requestResult.severity || (requestResult.success ? "success" : "error")}>
              {requestResult.message}
            </Alert>
          )}

          {!requestResult?.success && (
            <>
              {/* 1. Search Law Firm */}
              <Autocomplete
                freeSolo
                options={searchResults}
                getOptionLabel={(option) => {
                  if (typeof option === 'string') return option;
                  return option.city ? `${option.name} (${option.city})` : option.name;
                }}
                filterOptions={(x) => x}
                loading={isSearching}
                onInputChange={handleSearchFirms}
                onChange={handleSelectNewFirm}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Law Firm"
                    placeholder="Type law firm name (e.g. 'Pearson')..."
                    slotProps={{ input: { ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isSearching ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.lawfirm_id}>
                    <Typography variant="body1" fontWeight={500}>
                      {option.name}
                    </Typography>
                    {option.city && (
                      <Typography variant="body2" color="text.secondary" ml={1}>
                        — {option.city}
                      </Typography>
                    )}
                  </li>
                )}
              />

              {/* 2. Select Location (Only if firm selected) */}
              {selectedNewFirm && (
                <>
                  <Autocomplete
                    options={firmLocationsNew}
                    getOptionLabel={(option) => `${option.name} - ${option.city}`}
                    onChange={(e, val) => setSelectedNewLocation(val)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Location"
                      />
                    )}
                  />

                  <TextField
                    label="Message (Optional)"
                    placeholder="Enter a brief description for your request..."
                    multiline
                    rows={3}
                    value={requestMessage}
                    onChange={(e) => setRequestMessage(e.target.value)}
                  />
                </>
              )}
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowAddFirmDialog(false)}>
          {requestResult?.success ? "Close" : "Cancel"}
        </Button>
        {!requestResult?.success && (
          <Button
            variant="contained"
            onClick={handleRequestAccess}
            disabled={!selectedNewFirm || !selectedNewLocation || requestingAccess}
          >
            {requestingAccess ? "Requesting..." : "Request Access"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AddAnotherLawFirmDialog;
